import { useEffect } from 'react';

import { ANALYTICS_VISITOR_STATUS, VISITOR_STATUS } from 'constants/general';

import AnalyticsService from 'services/analyticsService';
import CookieService from 'services/cookieService';
import { PersonalizeSDKService } from 'services/personalize/sdkService';

import tastyworksApi from 'utils/tastyworksApi';

const COOKIE_EXPIRATION_DAYS = 3650;
const VISITOR_STATUS_COOKIE_NAME = 'visitorCookie';

async function updateVisitorStatus(status, updatePersonalize = false) {
  CookieService.set(VISITOR_STATUS_COOKIE_NAME, status, { expires: COOKIE_EXPIRATION_DAYS });
  AnalyticsService.pushData('visitor_status', ANALYTICS_VISITOR_STATUS[status]);
  if (!updatePersonalize) return;

  const personalizeStatus = status === VISITOR_STATUS.NEW_USER ? VISITOR_STATUS.RETURN_USER : status; // For personalize immediately set user segment to RETURN
  await PersonalizeSDKService.setAttribute('VISITOR_STATUS', personalizeStatus);
}

export const useVisitorStatus = () => {
  useEffect(() => {
    const checkAuthentication = async () => {
      const data = await tastyworksApi.validateSession();
      if (!data) return;
      await updateVisitorStatus(VISITOR_STATUS.AUTH_USER, true);
    };

    async function checkVisitorStatus() {
      const visitorCookie = CookieService.get(VISITOR_STATUS_COOKIE_NAME);
      const isUserAuthorized = visitorCookie === VISITOR_STATUS.AUTH_USER; // One user authorizes once, they are always AUTH_USER
      const isInitialVisit = typeof visitorCookie === 'undefined';

      if (isUserAuthorized) {
        await updateVisitorStatus(VISITOR_STATUS.AUTH_USER, true);
        return;
      }

      if (isInitialVisit) {
        await updateVisitorStatus(VISITOR_STATUS.NEW_USER, true);
        await checkAuthentication();
        return;
      }

      await updateVisitorStatus(VISITOR_STATUS.RETURN_USER, true);
      await checkAuthentication();
    }

    void checkVisitorStatus();
  }, []);
};
